<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    width: {
      type: String,
      default: '520px',
    },
  },
  methods: {
    hideModal() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<template>
  <a-modal
    :open="show"
    :footer="null"
    @cancel="hideModal"
    :width="width"
  >

    <slot :hide-modal="hideModal" ></slot>
  </a-modal>
</template>

<style scoped lang="scss">

</style>
